import { render } from "./MenuItem.vue?vue&type=template&id=33da8b0a&scoped=true"
import script from "./MenuItem.vue?vue&type=script&lang=js"
export * from "./MenuItem.vue?vue&type=script&lang=js"

import "./MenuItem.vue?vue&type=style&index=0&id=33da8b0a&scoped=true&lang=css"

import exportComponent from "/Users/enrico/Projects/perlamare/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33da8b0a"]])

export default __exports__